module.exports = __webpack_public_path__ + "static/img/noticia10.542e527f.jpg";